import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    FormGroup,
    FormControl,
    ControlLabel,
    Button,
    Alert
} from "react-bootstrap";

class ExperienceEditModal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            title: props.experience ? props.experience.title : '',
            content: props.experience ? props.experience.content : '',
            images: props.experience ? props.experience.images || [] : [],
            errors: {},
            isSubmitting: false
        };
    }

    componentDidUpdate(prevProps) {
        // Mettre à jour les champs si l'expérience change
        if (prevProps.experience !== this.props.experience && this.props.experience) {
            this.setState({
                title: this.props.experience.title,
                content: this.props.experience.content,
                images: this.props.experience.images || [],
                errors: {}
            });
        }
    }

    handleInputChange = (field, value) => {
        this.setState({
            [field]: value,
            errors: {
                ...this.state.errors,
                [field]: null
            }
        });
    };

    validateForm = () => {
        const errors = {};
        const { title, content } = this.state;

        if (!title.trim()) {
            errors.title = 'Le titre est obligatoire';
        } else if (title.trim().length < 5) {
            errors.title = 'Le titre doit contenir au moins 5 caractères';
        } else if (title.trim().length > 100) {
            errors.title = 'Le titre ne peut pas dépasser 100 caractères';
        }

        if (!content.trim()) {
            errors.content = 'Le contenu est obligatoire';
        } else if (content.trim().length < 20) {
            errors.content = 'Le contenu doit contenir au moins 20 caractères';
        } else if (content.trim().length > 2000) {
            errors.content = 'Le contenu ne peut pas dépasser 2000 caractères';
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!this.validateForm()) {
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            const { title, content, images } = this.state;
            
            const updatedData = {
                title: title.trim(),
                content: content.trim(),
                images: images
            };

            await this.props.onSave(updatedData);
            
        } catch (error) {
            this.setState({
                errors: {
                    submit: 'Une erreur est survenue lors de la modification. Veuillez réessayer.'
                }
            });
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const { show, onHide, experience } = this.props;
        const { title, content, errors, isSubmitting } = this.state;

        if (!experience) return null;

        return (
            <Modal
                show={show}
                onHide={onHide}
                bsSize="large"
                style={{ zIndex: 1050 }}
            >
                <Modal.Header 
                    closeButton
                    style={{
                        backgroundColor: '#f8f9fa',
                        borderBottom: '1px solid #e9ecef'
                    }}
                >
                    <Modal.Title style={{
                        color: '#2c3e50',
                        fontWeight: '600'
                    }}>
                        Modifier l'expérience
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body style={{ padding: '30px' }}>
                    <form onSubmit={this.handleSubmit}>
                        {/* Titre */}
                        <FormGroup validationState={errors.title ? 'error' : null}>
                            <ControlLabel>Titre de votre expérience *</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Ex: Mon expérience avec le traitement de..."
                                value={title}
                                onChange={(e) => this.handleInputChange('title', e.target.value)}
                                maxLength={100}
                                style={{
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    fontSize: '14px'
                                }}
                            />
                            {errors.title && (
                                <span className="help-block" style={{ color: '#e74c3c' }}>
                                    {errors.title}
                                </span>
                            )}
                            <span className="help-block" style={{ color: '#7f8c8d', fontSize: '12px' }}>
                                {title.length}/100 caractères
                            </span>
                        </FormGroup>

                        {/* Contenu */}
                        <FormGroup validationState={errors.content ? 'error' : null}>
                            <ControlLabel>Contenu de votre expérience *</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={8}
                                placeholder="Décrivez votre expérience en détail..."
                                value={content}
                                onChange={(e) => this.handleInputChange('content', e.target.value)}
                                maxLength={2000}
                                style={{
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    lineHeight: '1.5'
                                }}
                            />
                            {errors.content && (
                                <span className="help-block" style={{ color: '#e74c3c' }}>
                                    {errors.content}
                                </span>
                            )}
                            <span className="help-block" style={{ color: '#7f8c8d', fontSize: '12px' }}>
                                {content.length}/2000 caractères
                            </span>
                        </FormGroup>

                        {/* Erreur de soumission */}
                        {errors.submit && (
                            <Alert bsStyle="danger" style={{ marginTop: '20px' }}>
                                {errors.submit}
                            </Alert>
                        )}
                    </form>
                </Modal.Body>

                <Modal.Footer style={{
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #e9ecef',
                    padding: '20px 30px'
                }}>
                    <Button
                        onClick={onHide}
                        disabled={isSubmitting}
                        style={{
                            marginRight: '12px',
                            backgroundColor: 'transparent',
                            borderColor: '#dee2e6',
                            color: '#6c757d',
                            padding: '10px 20px',
                            borderRadius: '25px',
                            fontWeight: '500'
                        }}
                    >
                        Annuler
                    </Button>
                    <Button
                        onClick={this.handleSubmit}
                        disabled={isSubmitting}
                        style={{
                            backgroundColor: '#e67e22',
                            borderColor: '#e67e22',
                            color: 'white',
                            padding: '10px 24px',
                            borderRadius: '25px',
                            fontWeight: '600',
                            border: 'none'
                        }}
                    >
                        {isSubmitting ? (
                            <>
                                <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }} /> 
                                Modification...
                            </>
                        ) : (
                            <>
                                <i className="pe-7s-check" style={{ marginRight: '8px' }} /> 
                                Enregistrer les modifications
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ExperienceEditModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    experience: PropTypes.object,
    onSave: PropTypes.func.isRequired
};

export default ExperienceEditModal;